import { Component } from "react";
import { connect } from "react-redux";
import RecipeCardMobile from "./RecipeCardMobile";
import { Link } from "react-router-dom";
import { Recipe } from "../../types/shopify";
import { ReduxState } from "../../types/redux";

interface Props {
  recipeData?: RecipeData;
  shopifyRecipe?: Recipe;
  isShopifyRecipe?: boolean;
  isBlog?: boolean;
}

interface State {
  windowWidth: number;
  imageLoadHasFailed: boolean;
}

class RecipeCard extends Component<Props, State> {
  state = {
    windowWidth: 0,
    imageLoadHasFailed: false,
  };

  componentDidMount() {
    // get window screen width and height and set it for the components
    this.setScreenWidth();
    // track if the user rotates or changes
    window.addEventListener("resize", this.setScreenWidth);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.setScreenWidth);
  }

  setScreenWidth = () => {
    const windowWidth = window.innerWidth;
    this.setState({ windowWidth });
  };

  goToRecipe = () => {
    console.log("Go to recipe");
    window.history.pushState({}, `/recipes/${this.props.recipeData.id}`);
  };

  render() {
    const { recipeData, shopifyRecipe, isShopifyRecipe, isBlog } = this.props;
    
    // If no data is provided, return null
    if (!recipeData && !shopifyRecipe) {
      return null;
    }

    // if mobile screen width show mobile card
    if (this.state.windowWidth < 600) {
      if (isShopifyRecipe && shopifyRecipe) {
        return <RecipeCardMobile recipeData={null} shopifyRecipe={shopifyRecipe} isShopifyRecipe={true} isBlog={isBlog} />;
      } else if (recipeData) {
        return <RecipeCardMobile recipeData={recipeData} />;
      }
      return null;
    }

    // Render based on data type
    const id = isShopifyRecipe && shopifyRecipe ? shopifyRecipe.id : recipeData?.id?.toString() || '';
    const title = isShopifyRecipe && shopifyRecipe ? shopifyRecipe.title : recipeData?.title || '';
    const imagePath = isShopifyRecipe && shopifyRecipe && shopifyRecipe.image ? shopifyRecipe.image.url : recipeData?.imagePath;
    const excerpt = isShopifyRecipe && shopifyRecipe ? shopifyRecipe.excerpt : '';
    const publishedDate = isShopifyRecipe && shopifyRecipe ? new Date(shopifyRecipe.publishedAt).toLocaleDateString() : '';
    const author = isShopifyRecipe && shopifyRecipe && shopifyRecipe.author ? shopifyRecipe.author.name : '';
    
    return (
      <div>
        <div
          id={id}
          className={
            "card u-background--white u-br--small u-relative u-border--darkgrey "
          }
          style={{
            width: "250px",
            height: "500px",
          }}
        >
          <div className="u-p--8 u-flex u-flex-column">
            <div className="u-m0auto u-w-all u-text-center u-flex u-justify-center u-text-unselectable ">
              {imagePath ? (
                <img
                  id="item-image"
                  style={{ width: "100%", height: "180px", objectFit: "cover" }}
                  src={imagePath}
                  alt={title}
                  onError={() => {
                    this.setState({ imageLoadHasFailed: true });
                  }}
                />
              ) : (
                <div
                  className="u-background--grey u-w-all u-main-font--vsmall u-semi-bold u-text-center"
                  style={{ height: "180px", width: "100%" }}
                >
                  No image found.
                </div>
              )}
            </div>
            <div className="u-ph--12" style={{ height: "220px" }}>
              <div
                className="u-color-charcoal u-main-font--small u-text-unselectable u-pt--8 u-tooltip-wrap"
                style={{
                  lineHeight: "18px",
                  fontSize: "14px",
                }}
              >
                <div className="u-truncate--3l u-bold u-main-font--medium u-text-align-center">
                  {title}
                </div>
                
                {isShopifyRecipe && shopifyRecipe ? (
                  <>
                    <div className="u-truncate--3l u-main-font--small u-pt--8">
                      {excerpt}
                    </div>
                    <div className="u-flex u-pt--8 u-justify-between">
                      <div className="u-main-font--vsmall">
                        {publishedDate}
                      </div>
                      {author && (
                        <div className="u-main-font--vsmall">
                          By: {author}
                        </div>
                      )}
                    </div>
                  </>
                ) : (
                  <div className="u-flex u-pt--16">
                    <div className="u-w-half">
                      <div className="u-main-font--vsmall u-text-align-center u-bold">
                        PREP TIME
                      </div>
                      <div className="u-main-font--vsmall u-text-align-center">
                        {recipeData?.prepTimeMinutes}
                      </div>
                    </div>
                    <div className="u-w-half">
                      <div className="u-main-font--vsmall u-text-align-center u-bold">
                        COOK TIME
                      </div>
                      <div className="u-main-font--vsmall u-text-align-center">
                        {recipeData?.cookTimeMinutes}
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>

            <div className="u-w-all u-flex u-justify-center u-ph--16--desktop u-min-height--48 u-max-height--48">
              <Link
                className="u-w-all"
                to={isShopifyRecipe && shopifyRecipe 
                  ? (isBlog ? `/browse/blogs/${shopifyRecipe.handle}` : `/recipes/${shopifyRecipe.handle}`) 
                  : `/recipe/${recipeData?.id}`}
              >
                <button className="u-br--small u-background--magenta u-w-all">
                  <div className="u-color-white u-p--12 u-main-font--small u-bold u-text-unselectable ">
                    {isBlog ? 'View post' : 'View recipe'}
                  </div>
                </button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state: ReduxState) => ({
  recipes: state.recipes,
  shopifyRecipes: state.recipes.shopifyRecipes,
});

export default connect(mapStateToProps, null)(RecipeCard);
